<template>
  <div>
    <!-- START : Product Details Component -->
    <ProductDetailPageMobile
      v-if="!!item"
      :item="item"
      :priceEmbeddedLineItem="priceEmbeddedLineItem"
      :itemNotInList="itemNotInList"
      :scanMode="true"
      @handleProductView="handleProductView"
    />
    <!-- END : Product Details Component -->

    <!-- START: Scan and shopping list -->
    <template>
      <h1 class="text-center m-3" v-if="!item">{{ $t('scanAnItem') }}</h1>
      <p
        class="text-center mx-5 mt-2"
        v-if="!item && activeShoppingList && Object.keys(activeShoppingList).length"
      >
        {{ $t('asYouScanItems') }}
      </p>

      <!-- No shopping list -->
      <NoShoppingList v-if="!hasActiveShoppingList" :shoppingList="shoppingList" />

      <!-- Rendering active shopping list -->
      <ShoppingProductList
        v-else
        :activeShoppingList="activeShoppingList"
        @removeShoppingList="$emit('removeShoppingList')"
      />
    </template>
  </div>
</template>

<script>
import ProductDetailPageMobile from '../ProductDetailPage/ProductDetailPageMobile.vue';
import NoShoppingList from './components/NoShoppingList.vue';
import ShoppingProductList from './components/ShoppingProductList.vue';

export default {
  props: {
    item: {
      type: Object,
      required: false,
    },
    shoppingList: {
      type: Array,
      required: false,
    },
    activeShoppingList: {
      type: Object,
      required: false,
    },
    itemNotInList: {
      type: Boolean,
      required: true,
      default: false,
    },
    priceEmbeddedLineItem: {
      type: Object,
      required: false,
    },
  },
  components: {
    ProductDetailPageMobile,
    NoShoppingList,
    ShoppingProductList,
  },
  computed: {
    // Has item and active shopping list
    scanInstruction() {
      return !this.item && this.activeShoppingList && Object.keys(this.activeShoppingList).length;
    },

    // Has active shopping list
    hasActiveShoppingList() {
      return this.activeShoppingList && Object.keys(this.activeShoppingList).length;
    },
  },
  methods: {
    /**
     * Method to handle product detail view and navigating to product detail page
     */
    handleProductView() {
      this.$router.push({ path: `/i/${this.item?.id}`, query: { scan: true } });
    },
  },
};
</script>
